module.exports = __webpack_public_path__ + "img/logoLoading.d087ce58.png";